import { jsx as _jsx } from "react/jsx-runtime";
import FooterLayout from '../features/footer/FooterLayout';

const Footer = () => {
  return /*#__PURE__*/_jsx("footer", {
    children: /*#__PURE__*/_jsx(FooterLayout, {})
  });
};

export default Footer;